module.exports = "mutation deleteProduct($id:String!){deleteProduct(id:$id){id name}}"